import classes from './Img.module.css';

export default function Img() {
  return (
    <img src="https://cdn.seel.com/assets/images/op/login_img.svg" alt="" className={classes.img} />
  );
}
